import { PhAction, PhActions } from '../phActions';
import { AntragsummerGenerated } from '../action-types/antragsummerGenerated';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: PhAction<AntragsummerGenerated>,
): string {
  switch (action.type) {
    case PhActions.ANTRAGSNUMMER_GENERATED: {
      return action.payload.antragsnummer;
    }
    default:
      return sectionState;
  }
};
